<template>
  <div>
    <div class="row">
      <div class="col-12">
        <p class="text-right">
          <router-link class="btn btn-primary" :to="{ name: 'public-holidays.create' }">
            <font-awesome-icon :icon="['fal', 'plus-circle']" />
            Create
          </router-link>

          <router-link class="btn btn-success ml-2" :to="{ name: 'public-holidays.upload' }">
            <font-awesome-icon :icon="['fal', 'file-plus']" />
            Upload CSV
          </router-link>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <advanced-filter :refs="$refs" :select-filters="selectFilters" :date-range="true" />

        <v-server-table ref="table" url="/public-holidays" :columns="columns" :options="options" />
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import entity from "../../mixins/entity";
import format from "../../mixins/format";
import AdvancedFilter from "../../components/common/AdvancedFilter.vue";

const columns = ["name", "state", "date", "actions"];

export default {
  components: {
    AdvancedFilter,
  },

  mixins: [entity, format],

  data() {
    return {
      selectFilters: {
        state: {
          options: this.$store.state.address.stateObjects,
        },
      },

      columns,
      options: {
        advancedFilter: true,
        templates: {
          actions: (h, o) => this.entityActionSet(h, o, "public-holidays", this.$refs),
        },
      },
    };
  },
};
</script>
